module.exports = __webpack_public_path__ + "static/media/webdesign-services-img13.ecab243b.jpg";